import { gql } from '@apollo/client';

export const CREATE_REPORT = gql`
  mutation CreateReport($input: CreateReportInput!) {
    createReport(input: $input) {
      id
      title
      year
      framework
      progress
    }
  }
`;

export const UPDATE_REPORT = gql`
  mutation UpdateReport($input: UpdateReportInput!) {
    updateReport(input: $input) {
      id
      title
      year
      framework
      progress
    }
  }
`;

export const DELETE_REPORT = gql`
  mutation DeleteReport($reportId: ID!) {
    deleteReport(reportId: $reportId)
  }
`;

export const UPDATE_REPORT_INPUT = gql`
  mutation UpdateReportInput(
    $reportId: ID!
    $sectionId: ID!
    $input: String
    $isMarkedCompleted: Boolean
  ) {
    updateReportInput(
      reportId: $reportId
      sectionId: $sectionId
      input: $input
      isMarkedCompleted: $isMarkedCompleted
    ) {
      id
      isGenerating
      input
      isMarkedCompleted
    }
  }
`;

export const ASSIGN_REPORT_INPUTS = gql`
  mutation AssignReportInputs($input: AssignReportInput!) {
    assignReportInputs(input: $input)
  }
`;
